import { ChainIds, ChainNamespaces } from "../../consts";
import { DEFAULT_ETHERS_DECIMALS } from "../utils";

const commonConfig = {
  namespace: ChainNamespaces.EVM,
  symbol: "BNB",
  buyTezUrl: "",
  tzktApiUrl: "",
  chain: ChainIds.BSC,
  decimals: DEFAULT_ETHERS_DECIMALS,
};
export const bscConfig = {
  // Mainnet
  mainnet: {
    name: "BSC",
    identifier: "56",
    rpcUrl: "https://binance.llamarpc.com",
    explorerUrl: "https://bscscan.com",
    ...commonConfig,
  },
  // Testnet
  testnet: {
    name: "BSC Testnet",
    identifier: "97",
    rpcUrl: "https://bsc-testnet.publicnode.com",
    explorerUrl: "https://testnet.bscscan.com",
    isTestnet: true,
    ...commonConfig,
  },
} as const;
